import PosthogService from '~/services/posthog/PosthogService';

/**
 * How the shift came to be selected. Without this, one "Select All" click is
 * indistinguishable from N deliberate row clicks in the funnel.
 */
export type TBulkConfirmSelectionMethod = 'individual' | 'select_all';

export interface IBulkConfirmCandidateSelectedPayload {
  professionalId?: string;
  candidateId?: string;
  shiftId: string;
  offerId?: string;
  /** 1-indexed position of the selected shift row. */
  shiftNumber?: number;
  /** Total shift rows shown on the page. */
  shiftCount?: number;
  selectionMethod?: TBulkConfirmSelectionMethod;
}

/**
 * Fires when a shift is selected on the bulk "Confirm Shifts" page — once per
 * shift, including each row swept in by "Select All" (`selection_method`
 * distinguishes the two).
 *
 * Deselection is deliberately not tracked, in either direction: unchecking a row
 * and the clear-all half of the Select All toggle both emit nothing.
 *
 * `shiftNumber` / `shiftCount` are the selected row's position and the total rows
 * shown, matching candidate_viewed so a selection joins back to its impression.
 * `candidate_count` is always 1 — the page is scoped to one professional
 * (GOTU-4815).
 *
 * Event: dental_portal:bulk_confirm:candidate_selected
 */
export function fireBulkConfirmCandidateSelected(
  payload: IBulkConfirmCandidateSelectedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:candidate_selected', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_id: payload.shiftId,
    offer_id: payload.offerId,
    shift_number: payload.shiftNumber,
    shift_count: payload.shiftCount,
    selection_method: payload.selectionMethod,
    candidate_count: 1,
  });
}
